import { ReactNode } from 'react';

import { cn } from 'styles';

interface ActionTitleProps {
  className?: ReactNode;
  children: ReactNode;
}

function ActionTitle({ children, className }: ActionTitleProps): JSX.Element {
  return (
    <h3 className={cn('text-sm font-semibold text-muted-foreground', className)}>
      <>{children}</>
    </h3>
  );
}

export default ActionTitle;
